/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Notes_Switch_BodyInputs */



/**
* | output |
* | --- |
* | "Wundo sits in on the meeting and writes the report along with you." |
*
* @param {Meeting_Notes_Switch_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_notes_switch_body = /** @type {((inputs?: Meeting_Notes_Switch_BodyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Notes_Switch_BodyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Wundo sluit aan bij de meeting en schrijft het verslag.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Wundo rejoint la réunion et rédige le compte rendu.")
	return /** @type {LocalizedString} */ ("Wundo sits in on the meeting and writes the report along with you.")
});